import React from "react"
import Skeleton from '../UI/Skeleton'
import PropTypes from 'prop-types'
import { Card, CardBody, CardFooter } from 'reactstrap'

class CatalogCardEmulation extends React.Component {
    render() {
        return (
            <React.Fragment>
                {
                    this.props.cols === 2 ?
                        <Card className="d-flex flex-column border-10">
                            <Skeleton className="card-img-top border-top-10" height={240} />
                            <CardBody className="catalog-body">
                                <div className="d-flex justify-content-between align-items-start">
                                    <Skeleton className="news-title lg-font-size" width={280} />
                                    <Skeleton circle={true} width={28} height={28} className="favorite-icon" />
                                </div>
                                <div className="py-20">
                                    <Skeleton className="news-desc md-font-size py-0" count={5} />
                                </div>
                            </CardBody>
                            <CardFooter className="mt-auto">
                                <div className="card-tags">
                                    <Skeleton className="card-tag xs-font-size" width={80} count={5} />
                                </div>
                                <div className="catalog-white-space"></div>
                                <div className="catalog-card-bottom">
                                    <div className="catalog-price-wrapper">
                                        <Skeleton className="catalog-price-old xs-font-size" width={35} />
                                        <Skeleton className="catalog-price-new md-font-size" width={35} />
                                    </div>
                                    <Skeleton className="btn catalog-btn read" width={150} />
                                    <Skeleton className="btn catalog-btn primary addToCart" width={150} />
                                </div>
                            </CardFooter>
                        </Card>
                        :
                        <Card className="d-flex flex-row align-items-center border-10 big-catalog-card">
                            <Skeleton width={800} height={400} />
                            <div className="card-content">
                                <CardBody className="catalog-body">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <Skeleton className="news-title lg-font-size" width={280} />
                                        <Skeleton circle={true} width={28} height={28} className="favorite-icon" />
                                    </div>
                                    <div className="py-20">
                                        <Skeleton className="news-desc md-font-size py-0" count={5} />
                                    </div>
                                </CardBody>
                                <CardFooter className="mt-auto">
                                    <div className="card-tags">
                                        <Skeleton className="card-tag xs-font-size" width={80} count={5} />
                                    </div>
                                    <div className="catalog-white-space"></div>
                                    <div className="catalog-card-bottom">
                                        <div className="catalog-price-wrapper">
                                            <Skeleton className="catalog-price-old xs-font-size" width={35} />
                                            <Skeleton className="catalog-price-new md-font-size" width={35} />
                                        </div>
                                        <Skeleton className="btn catalog-btn read" width={150} />
                                        <Skeleton className="btn catalog-btn primary addToCart" width={150} />
                                    </div>
                                </CardFooter>
                            </div>
                        </Card>
                }
            </React.Fragment>
        )
    }
}

CatalogCardEmulation.propTypes = {
    cols: PropTypes.number,
}

export default CatalogCardEmulation


// WEBPACK FOOTER //
// ./src/components/Catalog/CatalogCardEmulation.jsx